import React, { useCallback, useEffect, useState } from 'react'
import {
    IconButton,
    Avatar,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    ListItemAvatar,
    Divider,
    Typography,
} from '@mui/material'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import ExitIcon from '@mui/icons-material/ExitToApp'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ROUTE from 'constant/route'
import { useAppSelector } from 'store/useStoreHook'
import { useLogout } from 'pages/LogoutPage/LogoutPage'
import useAdminRoute from 'router/useAdminRoute'
import { values } from 'lodash-es'
import { useGloballyConfig } from 'hooks/useGloballyConfig/useGloballyConfig'

function User() {
    const dispatch = useDispatch()
    const history = useHistory()
    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const handleClose = () => {
        setOpen(false)
    }
    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOpen(true)
        setAnchorEl(event.currentTarget)
    }
    useGloballyConfig()
    const { userPreferenceMenus } = useAdminRoute()
    const [userAvatar, setUserAvatar] = useState('')
    const userData = useAppSelector((state) => state.auth.user)
    const connectionId = useAppSelector((state) => state.client.connectionId)
    const clientName = useAppSelector(
        (state) => state.client.currentClient?.name,
    )
    const { pathname } = useLocation()

    useEffect(() => {
        setUserAvatar(
            userData?.firstName
                ? userData?.firstName?.slice(0, 1).toUpperCase() +
                      userData?.lastName?.slice(0, 1).toUpperCase()
                : '',
        )
    }, [dispatch, userData])

    const handleSwitchDevice = useCallback(() => {
        history.replace({
            pathname: ROUTE.SELECT_DEVICE,
            search: 'cancelable=1',
        })
    }, [history])
    const { handleOnLogout } = useLogout()

    useEffect(() => {
        // close user menu when change page (pathname changed) for reducing click amount when action on new page
        handleClose()
    }, [pathname])

    return (
        <div>
            <IconButton
                onClick={handleOpen}
                style={{ height: 48 }}
                size="large"
            >
                <Avatar
                    alt="User Name"
                    sx={{
                        backgroundColor: 'warning.main',
                        color: 'topside.paper',
                        height: '30px',
                        width: '30px',
                    }}
                >
                    {userAvatar}
                </Avatar>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    sx={{
                        width: '300px',
                    }}
                    onClick={() => history.push(ROUTE.MY_ACCOUNT)}
                >
                    <ListItemAvatar sx={{ mb: 'auto', mt: '9px' }}>
                        <Avatar
                            alt="User Name"
                            sx={{
                                backgroundColor: 'warning.main',
                                color: 'topside.paper',
                            }}
                        >
                            {userAvatar}
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                        <Typography
                            variant="h6"
                            sx={{
                                whiteSpace: 'break-spaces',
                                overflowWrap: 'break-word',
                            }}
                        >
                            {(userData?.firstName ?? '') +
                                ' ' +
                                (userData?.lastName ?? '')}
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                whiteSpace: 'break-spaces',
                                overflowWrap: 'break-word',
                            }}
                        >
                            {userData?.email ?? '-'}
                        </Typography>
                        <Typography variant="caption" component="div">
                            CID: {connectionId || 'N/A'}
                        </Typography>
                        <Typography variant="caption" component="div">
                            Terminal: {clientName || 'N/A'}
                        </Typography>
                    </ListItemText>
                </MenuItem>
                <Divider />
                {values(userPreferenceMenus).map((menu) => {
                    return (
                        <MenuItem
                            key={`menu-user-pos-${menu.path}`}
                            onClick={() => history.push(menu.path)}
                        >
                            <ListItemIcon>{menu.icon}</ListItemIcon>
                            <ListItemText>{menu.title}</ListItemText>
                        </MenuItem>
                    )
                })}
                <MenuItem onClick={handleSwitchDevice}>
                    <ListItemIcon>
                        <SwapHorizIcon />
                    </ListItemIcon>
                    <ListItemText>Switch Device</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleOnLogout}>
                    <ListItemIcon>
                        <ExitIcon />
                    </ListItemIcon>
                    <ListItemText>Log Out</ListItemText>
                </MenuItem>
            </Menu>
        </div>
    )
}
export default User
